<template slot="header">

  <div class="mfitem mfborder">
    <div class="center bold narrow_05">{{ item.KpiName }}<span v-if="hasAsterisk">&nbsp;*</span></div>

    <div v-for="(itm, index) in item.SurveyWave" :key="index">
      <div class="gwmi-container emsmalltext narrow_05">
        <div class="gwmi-left " >{{ itm.Name }}</div>
        <div v-bind:class="{ 'gwmi-center': showPoints, 'gwmi-center-large': !showPoints }">
          <div class="gwmi-center-container gebrauchtwagenbar-container"
               v-bind:class="{ 'disabled': !showPointsTooltips } "
               v-b-tooltip.html.hover.nofade="toolTipDelay" :title="getTooltip(itm)" >
            <div class="gebrauchtwagenbar-left"
                v-if="itm.Result > 0"
                v-bind:style="{ width: itm.Result + '%' }"
                v-bind:class="{ 'bc-green-gradient' : isGreen(itm), 'bc-yellow-gradient': isYellow(itm), 'bc-red-gradient': isRed(itm) }">
              <div v-if="itm.Result > 69"
                  class=" gebrauchtwagenbar-righttext"> <span>{{ itm.Result }}%</span>
              </div>
            </div>
            <div class="gebrauchtwagenbar-middle" v-if="shouldFillGap && itm.Result < 100">
              <div v-if="itm.Result < 70" class=" gebrauchtwagenbar-lefttext"> <span>{{ itm.Result }}%</span></div>
            </div>
          </div>
        </div>
        <div v-if="showPoints" class="gwmi-right">
          <div v-if="itm && itm.PointsMax && itm.PointsReached">
            {{ itm.PointsReached }} {{$t('Webportal.RangeOf')}} {{ itm.PointsMax }}
          </div>
        </div>
        <div v-if="!showPoints" class="gwmi-right-small">&nbsp;</div>
      </div>
    </div>

    <div>
      <div class="gwmi-container">
        <div class="gwmi-left"></div>
        <div v-bind:class="{ 'gwmi-center': showPoints, 'gwmi-center-large': !showPoints } ">
          <div class="narrow_05 gebrauchtwagenbar-lefttext">
            0<span v-if="isPercentage">%</span>
          </div>
          <div class="narrow_05 gebrauchtwagenbar-righttext">
            100<span v-if="isPercentage">%</span>
          </div>
        </div>
        <div v-if="showPoints" class="gwmi-right">&nbsp;</div>
        <div v-if="!showPoints" class="gwmi-right-small">&nbsp;</div>
      </div>
    </div>

  </div>

</template>

<script>

  export default {
    name: 'GebrauchtwagenMultiItem',

    data() {
      return {
        toolTipDelay: { delay: { "show": 500, "hide": 100 } }
      }
    },

    props: {
      hasAsterisk: Boolean,
      isPercentage: Boolean,
      shouldFillGap: Boolean,
      title: String,
      proHeader: String,
      contraHeader: String,
      pro: Number,
      contra: Number,
      points: Number,
      pointsMax: Number,
      tooltip: String,
      item: Object,
      showPoints: { type: Boolean, default: true },
      showPointsTooltips: { type: Boolean, default: true }
    },

    methods: {
      getTooltip(item) {
        if (!item.PointsReached || !item.PointsMax) {
          return '<h5>' + item.Name + '</h5>'
        }

        return '<h5>' + item.Name + '</h5>' + item.PointsReached + ' ' +
          this.$t('Webportal.RangeOf') + ' ' + item.PointsMax + ' ' +
          this.$t('Webportal.Dashboard.PointsReached');
      },
      isGreen (_item){
        return _item.Result > 89;
      },
      isYellow (_item){
        return _item.Result > 69 && _item.Result < 90;
      },
      isRed (_item){
        return _item.Result < 70;
      }
    },

    computed: {
      getResultWidth: function(_item) {
        return _item.Result;
      }
    }
  }

</script>

<style scoped>

</style>
